import { Entity, formatTicker } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FlagIcon } from '~/components/flag-icon/FlagIcon';
import { NonLinearStepper } from '~/components/non-linear-stepper/NonLinearStepper';
import { RegionIcon } from '~/components/region-icon/RegionIcon';
import { useThemeStore } from '~/components/theme-controller/stores/useThemeStore';
import { isDarkTheme } from '~/components/theme-controller/utils/theme-utils/theme-utils';

import * as S from './GeographicStepperSection.styles';

interface GeographicStepperSectionProps {
  entity: Entity;
  targetName: string;
  targetType: 'country' | 'region';
  title?: string;
  description?: string;
  activeIndex: number;
}

export const GeographicStepperSection = ({
  entity,
  targetName,
  targetType,
  title,
  activeIndex,
  description,
}: GeographicStepperSectionProps) => {
  const { t } = useTranslation(['widget']);
  const themeName = useThemeStore(state => state.themeName);
  const isDark = isDarkTheme(themeName);
  const logoUrl = isDark
    ? entity.logo_urls.light_png
    : entity.logo_urls.dark_png;

  return (
    <S.SectionRow data-testid="geographic-stepper-section">
      {title && <S.TitleMedium>{title}</S.TitleMedium>}
      <S.StepperWrapper>
        <NonLinearStepper
          steps={[
            {
              logoUrl: logoUrl,
              hoverLabel: formatTicker(entity),
              connectorLabel: t(
                'widget:assetOverview.knowledgeGraph.exposedTo'
              ),
              isSimple: false,
            },
            {
              imgNode:
                targetType === 'country' ? (
                  <FlagIcon
                    countryCode={targetName}
                    variant="circular"
                    customSize={23}
                  />
                ) : (
                  <RegionIcon region={targetName} size={23} />
                ),
              hoverLabel: targetName,
              iconColor: 'var(--kg-theme)',
            },
          ]}
          activeIndex={activeIndex}
          iconSize={23}
        />
      </S.StepperWrapper>
      {description && <S.BodySmall>{description}</S.BodySmall>}
    </S.SectionRow>
  );
};
